import { schema } from 'normalizr';

import { SCHEMA_TYPE_SINKS } from '../constants/schemaTypes';
import has from 'lodash/has';
import isNil from 'lodash/isNil';
import userSchema from './user';
import orgSchema from './org';
import credentialSchema from './credential';
import dataMapSchema from './dataMap';
import dataSetSchema from './dataSet';
import vendorEndpointSchema from './vendorEndpoint';

const sinkSchema = new schema.Entity(
  SCHEMA_TYPE_SINKS,
  {
    owner: userSchema,
    org: orgSchema,
    data_credentials: credentialSchema,
    data_map: dataMapSchema,
    data_set: dataSetSchema,
    vendor_endpoint: vendorEndpointSchema,
  },
  {
    processStrategy: (value) => {
      if (has(value, 'vendor') && !isNil(value.vendor)) {
        return { ...value, vendor_id: value.vendor.id };
      }

      return value;
    },
  },
);

export default sinkSchema;
